<template>
	<Modal 
		:loading="loading" 
		:title="'EDITAR ' + current.name.toUpperCase() "
		@close="close"
		@save="save"
	>
		<div class="row">
			<div class="col-xs">
				<FormInput v-model="new_nickname" label="Identificador para o rastreio" type="text" icon="fa-truck" :required="true" tooltip="Informe o identificador personalizado para o motorista" ref="nickname" />
			</div>
		</div>
	</Modal>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormInput from "@/components/FormInput";

export default {
	name: "DriverEdit",

	props: {
		current: {
			type: Object,
			require: true,
		}
	},

	components: { Modal, FormInput },

	data: function() {
		return {
			loading: false,
			new_nickname: this.current.nickname,
		}
	},

	methods: {
		// Envia para API e salva as informações no BD e XML
        save: async function() {
			if (!this.new_nickname) {
				this.$notification.error("Identificador inválido.");
				return;
			}

            let form = {};
            let result = null;

            form.id = this.current.id;
            form.nickname = this.new_nickname;

            this.loading = true;
            try {
                result = await Api.post("driver/edit-driver", form);
            } catch(ex) {
                console.log(ex);
                this.loading = false;
                this.$notification.error("Não foi possível editar este motorista.");
                return;
            }
            this.loading = false;

            if (result) {
                if (result.error) {
                    this.$notification.error(result.data);
                }
                
                this.$notification.success("Motorista foi editado com sucesso.");
                this.close();
                return;
            } else {
                this.$notification.error("Não foi possível editar este motorista.");
                return;
            }
		},

		/**
		 * Fecha o modal
		 **/ 
		close: function() {
			this.$emit("close");
		},
	}
}
</script>

<style scoped></style>